/**
 * orga-app-api - vorlagen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VorlagenBenutzerZugriff { 
    benutzer_id: string;
    darf_dokumente_verwalten?: boolean;
    darf_checklisten_verwalten?: boolean;
    darf_aufgaben_benutzer_berechtigungen_verwalten?: boolean;
    mandant_id: string;
    modified_on_utc: Date;
}

